import qs from 'qs'
import { withHeadersInstance } from './api-instance.js'
const baseUrl = process.env.VUE_APP_URL_API

export const GetResponsibleList = async function(locationId, parameters) {
    try {
        const queryUrl = '?' + qs.stringify(parameters)
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/location/${locationId}/responsibles${queryUrl}`,
        })
    } catch (e) {
        console.error(e)
        return e.response.data
    }
}

export const GetResponsible = async function(responsiblePublicId, locationId) {
    try {
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/location/${locationId}/responsible/${responsiblePublicId}`,
        })
    } catch (e) {
        console.error(e)
        return e.response.data
    }
}

export const PostResponsible = async function(data) {
    try {
        if (data === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: data')
            )
        return await withHeadersInstance({
            method: 'post',
            url: `${baseUrl}/responsible`,
            data: data,
        })
    } catch (e) {
        console.error(e)
        return e.response
    }
}

export const UpdateResponsible = async function(responsible) {
    try {
        const { publicId } = responsible
        if (publicId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: publicId')
            )

        return await withHeadersInstance({
            method: 'put',
            url: `${baseUrl}/responsible/${publicId}`,
            data: responsible,
        })
    } catch (e) {
        console.error(e)
        return e.response
    }
}

export const DeleteResponsible = async function({
    responsiblePublicId,
    locationPublicId,
}) {
    try {
        if (responsiblePublicId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: responsiblePublicId')
            )
        if (locationPublicId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: locationPublicId')
            )
        return await withHeadersInstance({
            method: 'delete',
            url: `${baseUrl}/location/${locationPublicId}/responsible/${responsiblePublicId}`,
        })
    } catch (e) {
        console.error(e)
    }
}
